import React from 'react'
import styled from 'styled-components'
import ContactForm from './ContactForm'

const Footer = () => {
  return (
    <Wrapper>
    <div id='contact-target' className='main-content'>
      <div className='contact-con'>
        <h1 className='contact'>Get in touch</h1>
      </div>
      <div className='table-container'>
        <div>
        <div className="table">
            <p className='title'>Phone</p>
            <p className='title-value'>+91 7696025886</p>
            <p className='title'>Skype</p>
            <p className='title-value'>live:.cid.fd5b545a30b8448f</p>
            <p className='title'>Email</p>
            <p className='title-value'>yogrival911@gmail.com</p>

          </div>
        </div>
        <div>
          <ContactForm/>
        </div>
      </div>
    </div>
    </Wrapper>

  )
}

const Wrapper =  styled.section`
background-color: #FF3CAC;
background-image: linear-gradient(225deg, #FF3CAC 0%, #784BA0 50%, #2B86C5 100%);

.main-content{
  width: 80%;
margin: auto;
}
p {
    color: white;
    margin: 0.3rem 0;
  }

.table-container{
  padding: 2rem 0;
  display: grid;
  grid-template-columns: 40% auto;

}
.table {
    display: grid;
    grid-template-columns: 30% 80%;
    /* background-color: aqua;s */
    /* grid-gap: 1rem ; */

    /* background-color: red; */
  }
  .contact{
    color: white;
    padding-top: 1rem;
    /* background-color: red; */
 
  }
  .contact-con{
    /* color: white; */
    margin-top: 4rem;
 
  }
  .title-value{
    font-size: small;
  }
  .title{
    font-weight: bold;
    font-size: small;
  }
  .contact{
    margin-top: 4rem;
  }
  @media (max-width: 500px) {
    .table-container {
      display: flex;
      flex-direction: column;
    }
  }
`

export default Footer